/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Wallet } from "./Wallet";
import * as t from "io-ts";

// required attributes
const WalletListResponseR = t.interface({});

// optional attributes
const WalletListResponseO = t.partial({
  data: t.readonlyArray(Wallet, "array of Wallet")
});

export const WalletListResponse = t.intersection(
  [WalletListResponseR, WalletListResponseO],
  "WalletListResponse"
);

export type WalletListResponse = t.TypeOf<typeof WalletListResponse>;
